export default __webpack_public_path__ + "static/media/O_sound.373faaa9.mp3";